exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donutchart-track {\n  fill: transparent;\n  stroke: #dae2e5;\n  stroke-width: 26; }\n\n.donutchart-indicator {\n  fill: transparent;\n  stroke: #009688;\n  stroke-width: 26;\n  stroke-dasharray: 0 10000;\n  -webkit-transition: all 2s linear;\n  -o-transition: all 2s linear;\n  transition: all 2s linear; }\n\n.donutchart {\n  margin: 0 auto;\n  border-radius: 50%;\n  display: block; }\n\n.donutchart-text {\n  fill: #607580; }\n\n.donutchart-text-val {\n  font-size: 4em; }\n\n.donutchart-text-percent {\n  font-size: 2em; }\n\n.donutchart-text-label {\n  font-size: 1.2em; }\n\n.donut-container {\n  text-align: center;\n  margin-top: 30px;\n  margin-bottom: 30px; }\n\n.donutchart-line {\n  stroke: #c8c8c8;\n  stroke-width: 1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/donut.scss
// module id = 1543
// module chunks = 0